import { useEffect, useRef, useCallback } from "react";

export function useOnBackBrowserButton(onBack: () => void) {
  const onBackRef = useRef(onBack);

  useEffect(() => {
    onBackRef.current = onBack;
  }, [onBack]);

  const handlePopState = useCallback((event: PopStateEvent) => {
    onBackRef.current();
    history.pushState({ trapped: true }, "");
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const currentState = history.state;
    if (!currentState?.trapped) {
      history.pushState({ trapped: true }, "");
    }

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [handlePopState]);
}
